import { render, staticRenderFns } from "./WidgetCreate.vue?vue&type=template&id=458e9149&scoped=true"
import script from "./WidgetCreate.vue?vue&type=script&lang=js"
export * from "./WidgetCreate.vue?vue&type=script&lang=js"
import style0 from "./WidgetCreate.vue?vue&type=style&index=0&id=458e9149&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458e9149",
  null
  
)

export default component.exports